module.exports = __webpack_public_path__ + "static/media/test16_5.6d101965.png";